import React, { PureComponent } from 'react';
import { styles } from './styles';
import AddTestDialog from '../../../addTestDialog/addTestDialog'
import { Button, Link, Typography, withStyles, WithStyles } from '@material-ui/core';
import { dateService } from '../../../../../../common';
import ToggleInput from '../../../../../../common/ToggleInput';
import CustomInfoIcon from '../../../../../../common/CustomInfoIcon';
import { HIDE_TEST_POPUP_INFO } from '../../../../../Constants/constants';

const dateStyle = {
  color: '#999',
  fontSize: '16px',
  lineHeight: '18px',
  // marginBottom: '10px',
  display: 'inline-block',
};
const bullets = {
  color: '#C4C4C4',
  padding: '0px 10px',
  // marginTop: '5px',
};

interface PreviewTestStates {
  viewTest: boolean;
}

interface PreviewTestProps extends WithStyles<typeof styles> {
  classes: any;
  test: any;
  isWeek: boolean;
  phase: any;
  phaseIndex: number;
  isExtraTests?: boolean;
  packageEndDate: string | Date;
  showTestVisibility?: boolean;
}

class PreviewTest extends PureComponent<PreviewTestProps, PreviewTestStates> {
  constructor (props: PreviewTestProps) {
    super(props);
    this.state = {
      viewTest : false,
    }
  }

  toggleViewTest = () => {
    this.setState((previousState: any) => ({
      viewTest: !previousState.viewTest,
    }));
  }

  getDate = () => {
      let testTime;
      if (this.props.test.startDate) {
        const date = new Date(this.props.test.startDate.toString());
        if(this.props.test.endDate){
          const endDate = new Date(this.props.test.endDate.toString());
          testTime = `${dateService.timeDate(date)} - ${dateService.timeDate(endDate)}`
          return testTime;
        }
        testTime = dateService.timeDate(date);
        return testTime;
      }
      return 'Date not found!';
  };

  redirectUrl = (id: any, e: any) => {
    e.stopPropagation();
    if(id && id !== '000000000000000000000000'){
    let url = '/content/preview/' + id + 'testpapers';
    window.open(url, '_blank');
    }
  };

  render() {
    const { test, classes, isWeek, phase, phaseIndex, isExtraTests, packageEndDate, showTestVisibility } = this.props;
    const { viewTest } = this.state;
    const dropDownStringArray = ['Goal'];
    const textFieldStringArray = [
          { title: 'Test Name', name: 'testName', value: 'displayName' },
          {
            title: 'Test Syllabus',
            name: 'testSyllabus',
            value: 'paperDetail.syllabus.text',
          },
        ];
    const durationAttemptRevision = [
          { title: 'Duration', name: 'duration', value: 'duration' },
          { title: 'Max Attempt', name: 'maxAttempt', value: 'maxAttempt' },
          {
            title: 'Block Revision Time for This Test',
            name: 'blockRevisionTime',
            value: 'blockRevisionTime',
          },
        ];

    return (
      <div
        style={{
          borderBottom: '1px solid lightgrey',
          padding: `1% 2%`,
        }}
      >
        <div className={classes.displayFlex}>
        {isWeek ?
        (
          <span className={classes.displayFlex}>
            <img src='/assets/svg/test-icon.svg' alt='target-icon' />
          </span>
        ) :
        (<span className={classes.displayFlex}>
            <img src='/assets/svg/goalGreyNav.svg' alt='target-icon' />
        </span>)
        }
          <div>
          <Typography className={[classes.marginL10, classes.displayFlex].join(' ')}>
            &nbsp;
            <span className={classes.testTitle}>{test.name || test.displayName || 'Unnamed Test'}</span>
            <span style={bullets}>&bull;</span>
            <span style={dateStyle}>{this.getDate()}</span>
          </Typography>
          <div className={classes.marginL10} style={{ display: 'flex', justifyContent: 'space-between', marginLeft: '15px' }}>
           {test.syllabus ? <span style={{ display: 'flex', maxWidth: '900px'}} dangerouslySetInnerHTML={{ __html: test.syllabus.replace(/(<\/?(?:mark)[^>]*>)|<[^>]+>/ig, "$1")  }}>
            </span> : <></>}
          </div>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginLeft: "auto",
            }}
          >
          {showTestVisibility && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginRight: "15px",
              }}
            >
              Hide Test <CustomInfoIcon
                infoDialogContentType="Hide Test"
                isCenterArrow={true}
                isRightArrow={false}
                isInfoIcon={true}
                knowMoreAbout={false}
                dialogTitle="Hide Test"
                dialogPara={HIDE_TEST_POPUP_INFO}
                details="Click to know more"
                toolTipDirection="top"
              />
              <ToggleInput
                isChecked={test.isHidden}
                disabled={true}
              />
            </div>
          )}
          <Link 
          // onClick={() => this.toggleViewTest()} We need to redirect instead of showing popup
          onClick={(e: any) => {
            this.redirectUrl(test.testId, e);
          }}
          className={test.testId && test.testId !== '000000000000000000000000' ? classes.viewTestBtn: classes.disabledLink}
          >
              View Test
          </Link>
          </div>
        {/* {
          <AddTestDialog 
            title='View Test' 
            dropDownStringArray={dropDownStringArray} 
            textFieldStringArray={textFieldStringArray} 
            dialogButtonName='Add Test'
            buttonName='Add Test Dialog'
            isExistingTest={true}
            durationAttemptRevision={durationAttemptRevision}
            isRequiredMapTest={true}
            isExistingAndScheduledTest={true}
            isRequiredDate={true}
            open={viewTest}
            handleToggleOpen={this.toggleViewTest}
            editTestDetails={test}
            isPreview={true}
            phaseIndex={phaseIndex}
            packageEndDate={packageEndDate}
            isExtraTests={isExtraTests}
            phase={phase}
          />
        } */}
        </div>
      </div>
    );
  }
}
// @ts-ignore
export default withStyles(styles)(PreviewTest);
